import dateformat from "dateformat";
import React from "react";

type Props = {
  date?: string;
  id?: string;
};

const Header: React.FC<Props> = ({ date, id }): JSX.Element => {
  return (
    <div
      className="flex flex-row w-full justify-between mt-12"
      style={{
        borderBottom: "1px solid #D6D6D6",
      }}
    >
      <div className="flex flex-col mb-6">
        <span
          className="font-sora text-lg"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#8E8E8E",
          }}
        >
          {id ? "Last Update" : "New Term"}
        </span>
      </div>
      <div className="flex flex-col">
        <span
          className="font-sora text-xl"
          style={{
            fontStyle: "normal",
            fontWeight: 700,
            color: "#4F4F4F",
          }}
        >
          {dateformat(date ? date : Date(), "fullDate")}
        </span>
      </div>
    </div>
  );
};

export default Header;
